<template>
  <div
    class="listing-image"
    ref="image">
    <div v-if="!isError">
      <img
        class="listing-image__image"
        @error="handleError"
        v-lazy="src"
        draggable="false">
    </div>
    <div
      class="error-placeholder"
      v-else>
      <div>
        <div style="color: #BEBFC0; margin-bottom: 10px;">
          <font-awesome-icon
            v-if="width > 120"
            size="lg"
            :icon="['fas', 'unlink']"/>
        </div>
        <div>
          <span
            class="text-muted"
            :class="width > 120 ? 'h5': 'h6'">
            Image Not Found
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ListingImage',
  data() {
    return {
      isError: false,
    }
  },
  props: {
    src: {
      type: String,
      required: false,
      default: '',
    },
  },
  methods: {
    handleError() {
      this.isError = true
    },
  },
  computed: {
    width() {
      return this.$refs.image.clientWidth
    },
  },
  mounted() {
    if (!this.src) {
      this.isError = true
    }
  },
}
</script>

<style lang="scss" scoped>
.listing-image {
  width: 100%;
}

.listing-image__image {
  width: 100%;
  border-radius: 5px;
}

.error-placeholder {
  border-radius: 5px;
  width: 100%;
  padding: 10%;
  box-sizing: border-box;
  text-align: center;
  position: relative;
  background-color: #F3F4F5;
  display: flex;
  justify-content: center;
  align-items: center;
}

.error-placeholder:after {
  content: "";
  display: block;
  padding-bottom: 100%;
}
</style>
